import { Route } from '../route';
import { submitter } from '../submitter/submitter';
import { BaseMetric } from './base-metric';
export class Metric extends BaseMetric {
  start({
    startTime
  } = {}) {
    super.start({
      startTime
    });
    this.route = Route.getRoute();
  }

  stop(params = {}) {
    const stoppedSuccessfully = super.stop(params);

    if (stoppedSuccessfully && !this.config.virtual) {
      submitter.queue(this.getData());
    }

    return stoppedSuccessfully;
  }

}